__turbopack_context__.v({
  "className": "jetbrains_mono_13b10504-module__696lgG__className",
  "variable": "jetbrains_mono_13b10504-module__696lgG__variable",
});
